module.exports = __webpack_public_path__ + "static/media/PrecentCircle.a3b125b9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/PrecentCircle.svg
// module id = 62
// module chunks = 0